import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from '@core/backend/common/api/http.service';
import {
    FindGeospatialOutagesRequest,
    GeoJSONGeometry,
    FindGeospatialEntitiesRequest,
    GeospatialSearchAssetRequest,
} from '../model/api';
import {GeospatialTooltipRequest, GeospatialTooltipResponse} from '../model/tooltip.model';
import {GeospatialEntitiesConfiguration, GeospatialOutageEntitiesConfiguration} from '../model/viewer-config';
import {APIResponse} from '@core/interfaces/system/system-common';
import {SubstationAssetListRequest, SubstationAssetListResponse} from '../model/substation.model';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';

@Injectable()
export class GeospatialViewerApi {
    private prefix = 'geospatial';
    private prefixOutage = 'outage/spatial';

    constructor(private api: HttpService) {}

    public getMapGeoEntities(
        workflowItemId: number,
        req: FindGeospatialEntitiesRequest,
    ): Observable<GeospatialEntitiesConfiguration> {
        return this.api.post(`${this.prefix}/${workflowItemId}/entities`, req);
    }

    public getMapGeoOutageEntities(
        req: FindGeospatialOutagesRequest,
    ): Observable<APIResponse<GeospatialOutageEntitiesConfiguration>> {
        return this.api.post(`${this.prefixOutage}/entities`, req);
    }

    public getGeospatialTooltipData(
        workflowItemId: number,
        request: GeospatialTooltipRequest,
    ): Observable<GeospatialTooltipResponse> {
        if (workflowItemId != null) {
            return this.api.post(`${this.prefix}/tooltip/${workflowItemId}`, request);
        }
        return this.api.post(`${this.prefix}/tooltip`, request);
    }

    public getSearchAssetList(req: GeospatialSearchAssetRequest): Observable<any> {
        const query = `?assetId=${req.assetId}&workflowItemId=${req.workflowItemId}`;
        return this.api.get(`${this.prefix}/search/asset${query}`);
    }

    public getSearchAssetInfo(req: string): Observable<GeoJSONGeometry> {
        const query = `?assetId=${req}`;
        return this.api.get(`${this.prefix}/asset${query}`);
    }

    public getSubstationAssetList(
        workflowItemId: number,
        request: SubstationAssetListRequest,
    ): Observable<SubstationAssetListResponse> {
        return this.api.post(`${this.prefix}/${workflowItemId}/asset/list`, request);
    }
}
